
import React, {Component} from 'react';
import {View, Text, TextInput, TouchableOpacity, ScrollView, Modal} from 'react-native';
import modalStyles from '../../style/boxChampCalculateModal';
import {validateAddBox, addBoxPayload} from './boxChampOptions';

const palette = {
  text: '#ffffff',
  body: '#E0E7EF',
  muted: '#9aafc0',
  border: '#3d5a73',
  row: '#253c57',
  field: '#1a2a3a',
  danger: '#e74c3c',
  disabled: '#5c778f',
};

const label = {
  fontFamily: 'Poppins_500Medium',
  fontSize: 12,
  color: '#9aafc0',
};

const EMPTY_FORM = {
  name: '', barcode: '', length: '', width: '', height: '', maxWeight: '',
};

export default class BoxChampOptionsSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {mode: 'menu', picker: null, form: {...EMPTY_FORM}, errors: {}, submitting: false};
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({mode: 'menu', picker: null, form: {...EMPTY_FORM}, errors: {}, submitting: false});
    }
    if (this.props.serverError && this.state.submitting) {
      this.setState({submitting: false});
    }
  }

  openPicker = purpose => this.setState({mode: 'picker', picker: purpose});

  choose = boxTypeId => {
    if (this.state.submitting) return;
    const {picker} = this.state;
    this.setState({submitting: true, mode: 'menu', picker: null});
    if (picker === 'substitute' && this.props.onSubstitute) {
      this.props.onSubstitute(boxTypeId);
    } else if (picker === 'split' && this.props.onSplit) {
      this.props.onSplit(boxTypeId);
    }
  };

  setField = (key, value) =>
    this.setState(prev => ({form: {...prev.form, [key]: value}}));

  submitAddBox = () => {
    if (this.state.submitting) return;
    const {form} = this.state;
    const {valid, errors} = validateAddBox(form, this.props.catalog);
    if (!valid) {
      this.setState({errors});
      return;
    }
    this.setState({errors: {}, submitting: true});
    if (this.props.onAddBox) this.props.onAddBox(addBoxPayload(form));
  };

  renderAction(key, text, enabled, reason, onPress) {
    return (
      <View style={{marginBottom: 8}}>
        <TouchableOpacity
          testID={`boxchamp-option-${key}`}
          disabled={!enabled}
          onPress={() => {
            if (enabled && onPress) onPress();
          }}
          style={[
            modalStyles.groupRow,
            {
              marginBottom: 0,
              backgroundColor: enabled ? palette.row : 'transparent',
              borderWidth: enabled ? 0 : 1,
              borderColor: palette.disabled,
            },
          ]}>
          <Text
            style={{
              fontFamily: 'Poppins_500Medium',
              fontSize: 14,
              color: enabled ? palette.text : palette.disabled,
            }}>
            {text}
          </Text>
        </TouchableOpacity>
        {!enabled && !!reason && (
          <Text
            testID={`boxchamp-option-${key}-reason`}
            style={[modalStyles.orderText, {marginTop: 4, marginLeft: 2}]}>
            {reason}
          </Text>
        )}
      </View>
    );
  }

  renderField(key, fieldLabel, testID, extra = {}) {
    const error = this.state.errors[key];
    return (
      <View style={{marginBottom: 10}}>
        <Text style={[label, {marginBottom: 4}]}>{fieldLabel}</Text>
        <TextInput
          testID={testID}
          value={this.state.form[key]}
          onChangeText={value => this.setField(key, value)}
          style={{
            backgroundColor: palette.field,
            color: palette.text,
            borderWidth: 1,
            borderColor: palette.border,
            borderRadius: 6,
            paddingHorizontal: 10,
            paddingVertical: 9,
            fontFamily: 'Poppins_500Medium',
            fontSize: 14,
          }}
          {...extra}
        />
        {!!error && (
          <Text
            testID={`boxchamp-add-box-error-${key}`}
            style={{
              fontFamily: 'Poppins_500Medium',
              fontSize: 12.5,
              color: palette.danger,
              marginTop: 3,
            }}>
            {error}
          </Text>
        )}
      </View>
    );
  }

  renderMenu(options) {
    return (
      <View>
        {!!options.disabledReason && (
          <Text
            testID="boxchamp-options-disabled-reason"
            style={[modalStyles.groupLabel, {marginBottom: 12}]}>
            {options.disabledReason}
          </Text>
        )}
        {!!this.props.catalogError && (
          <TouchableOpacity
            testID="boxchamp-catalog-error"
            onPress={() => {
              if (this.props.onRetryCatalog) this.props.onRetryCatalog();
            }}
            style={{marginBottom: 12}}>
            <Text
              style={{
                fontFamily: 'Poppins_500Medium',
                fontSize: 12.5,
                color: palette.danger,
              }}>
              {this.props.catalogError}
            </Text>
          </TouchableOpacity>
        )}
        {this.renderAction(
          'substitute', 'Use a different box', options.canSubstitute,
          options.disabledReason, () => this.openPicker('substitute'),
        )}
        {this.renderAction(
          'combine', "Add the next box's items to this one", options.canCombine,
          options.combineReason || options.disabledReason, this.props.onCombine,
        )}
        {this.renderAction(
          'split', 'Move remaining items to a new box', options.canSplit,
          options.splitReason || options.disabledReason, () => this.openPicker('split'),
        )}
        {this.renderAction(
          'add-box', 'Add a new box to the catalog', options.canAddBox, null,
          () => this.setState({mode: 'add'}),
        )}
      </View>
    );
  }

  renderPicker() {
    const catalog = Array.isArray(this.props.catalog) ? this.props.catalog : [];
    return (
      <View>
        <Text style={[label, {marginBottom: 8}]}>
          {this.state.picker === 'split' ? 'New box type' : 'Which box are you using?'}
        </Text>
        {!!this.props.catalogError && catalog.length === 0 && (
          <Text
            testID="boxchamp-picker-catalog-error"
            style={[modalStyles.orderText, {marginBottom: 8, color: palette.danger}]}>
            {this.props.catalogError}
          </Text>
        )}
        <ScrollView style={modalStyles.scrollArea}>
          {catalog.map(boxType => (
            <TouchableOpacity
              key={`catalog-${boxType.id}`}
              testID={`boxchamp-catalog-option-${boxType.id}`}
              onPress={() => this.choose(boxType.id)}
              style={[modalStyles.groupRow, {flexDirection: 'column', alignItems: 'flex-start'}]}>
              <Text
                style={{
                  fontFamily: 'Poppins_500Medium',
                  fontSize: 14,
                  color: palette.text,
                }}>
                {boxType.name || boxType.box_id}
              </Text>
              {!!(boxType.length && boxType.width && boxType.height) && (
                <Text style={modalStyles.orderText}>
                  {boxType.length} × {boxType.width} × {boxType.height}
                </Text>
              )}
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    );
  }

  renderAddBox() {
    return (
      <View>
        {!!this.props.serverError && (
          <Text
            testID="boxchamp-add-box-server-error"
            style={{
              fontFamily: 'Poppins_500Medium',
              fontSize: 13.5,
              color: palette.danger,
              marginBottom: 10,
            }}>
            {this.props.serverError}
          </Text>
        )}
        {this.renderField('name', 'Name', 'boxchamp-add-box-name')}
        {this.renderField('barcode', 'Barcode (optional)', 'boxchamp-add-box-barcode')}
        {this.renderField('length', 'Length', 'boxchamp-add-box-length', {
          keyboardType: 'numeric',
        })}
        {this.renderField('width', 'Width', 'boxchamp-add-box-width', {
          keyboardType: 'numeric',
        })}
        {this.renderField('height', 'Height', 'boxchamp-add-box-height', {
          keyboardType: 'numeric',
        })}
        {this.renderField('maxWeight', 'Weight capacity', 'boxchamp-add-box-max-weight', {
          keyboardType: 'numeric',
        })}
      </View>
    );
  }

  render() {
    const {visible, options, onClose} = this.props;
    if (!visible || !options) return null;
    const {mode} = this.state;

    return (
      <Modal visible={true} transparent={true} animationType="fade" onRequestClose={onClose}>
        <View testID="boxchamp-options-overlay" style={[modalStyles.overlay, {padding: 16}]}>
          <TouchableOpacity
            testID="boxchamp-options-backdrop"
            activeOpacity={1}
            onPress={onClose}
            style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0}}
          />
      <View
        testID="boxchamp-options-sheet"
        style={[modalStyles.dialog, {width: '100%', maxWidth: 520}]}>
        <View style={modalStyles.header}>
          <Text testID="boxchamp-options-title" style={modalStyles.headerTitle}>
            {mode === 'add' ? 'Add a new box' : `Box options — ${options.boxName || ''}`}
          </Text>
          <TouchableOpacity
            testID="boxchamp-options-close"
            onPress={onClose}
            style={modalStyles.closeIcon}>
            <Text style={{color: palette.muted, fontSize: 18}}>✕</Text>
          </TouchableOpacity>
        </View>

        <View style={modalStyles.body}>
          {mode === 'menu' && this.renderMenu(options)}
          {mode === 'picker' && this.renderPicker()}
          {mode === 'add' && this.renderAddBox()}
        </View>

        {mode !== 'menu' && (
          <View style={modalStyles.footer}>
            <TouchableOpacity
              testID="boxchamp-options-back"
              onPress={() => this.setState({mode: 'menu', picker: null, errors: {}})}
              style={modalStyles.cancelButton}>
              <Text style={modalStyles.cancelButtonText}>Back</Text>
            </TouchableOpacity>
            {mode === 'add' && (
              <TouchableOpacity
                testID="boxchamp-add-box-submit"
                onPress={this.submitAddBox}
                style={modalStyles.queueButton}>
                <Text style={modalStyles.queueButtonText}>Save and use this box</Text>
              </TouchableOpacity>
            )}
          </View>
        )}
        </View>
        </View>
      </Modal>
    );
  }
}
